import React from 'react';
import { Container, Typography, Box, Divider } from '@mui/material';

const TermsPage: React.FC = () => {
  return (
    <Container maxWidth="md" sx={{ py: 8 }}>
      <Typography variant="h3" component="h1" gutterBottom fontWeight={700}>
        Conditions Générales
      </Typography>
      <Typography variant="body2" color="text.secondary" gutterBottom>
        Dernière mise à jour : mai 2026
      </Typography>

      <Divider sx={{ my: 3 }} />

      <Section title="1. Objet">
        Les présentes conditions générales régissent la prise de rendez-vous en ligne auprès de
        Desiree African Hair Braiding, situé à Fontana, Californie. En confirmant une réservation,
        vous acceptez l'ensemble des dispositions ci-dessous.
      </Section>

      <Section title="2. Réservation">
        La réservation en ligne est confirmée dès réception d'un email de confirmation. Nous nous
        réservons le droit d'annuler ou de modifier un rendez-vous en cas de circonstances
        exceptionnelles, avec notification préalable du client.
      </Section>

      <Section title="3. Annulation et modification">
        Toute annulation ou modification doit être effectuée au moins <strong>24 heures</strong> avant
        l'heure du rendez-vous. En dessous de ce délai, le rendez-vous est considéré comme honoré.
        Les modifications peuvent être réalisées via le lien fourni dans l'email de confirmation.
      </Section>

      <Section title="4. Retard">
        En cas de retard de plus de <strong>15 minutes</strong>, nous nous réservons le droit
        d'annuler le rendez-vous afin de ne pas pénaliser les clients suivants. Merci de nous
        contacter dès que possible si vous anticipez un retard.
      </Section>

      <Section title="5. Données personnelles">
        Les informations collectées lors de la réservation (nom, téléphone, email) sont utilisées
        uniquement dans le cadre de la gestion des rendez-vous et de l'envoi de confirmations et
        rappels. Elles ne sont jamais transmises à des tiers. Conformément à la loi applicable,
        vous disposez d'un droit d'accès, de rectification et de suppression de vos données en
        nous contactant directement.
      </Section>

      <Section title="6. Responsabilité">
        Desiree African Hair Braiding ne saurait être tenu responsable des dommages indirects
        résultant de l'utilisation du service de réservation en ligne. Notre responsabilité est
        limitée aux services effectivement rendus.
      </Section>

      <Section title="7. Contact">
        Pour toute question relative aux présentes conditions, vous pouvez nous contacter via la
        page Contact de notre site ou par téléphone au numéro indiqué sur notre site.
      </Section>
    </Container>
  );
};

const Section: React.FC<{ title: string; children: React.ReactNode }> = ({ title, children }) => (
  <Box sx={{ mb: 4 }}>
    <Typography variant="h6" fontWeight={700} gutterBottom>
      {title}
    </Typography>
    <Typography variant="body1" color="text.secondary" lineHeight={1.8}>
      {children}
    </Typography>
  </Box>
);

export default TermsPage;
